// Qué creaciones seleccionadas se le pasan a "Enviar a lanzamiento" —
// ADR-2026-09-13-lanzamiento-en-creaciones-anteriores.
//
// Existe porque acá estuvo el bug: la pantalla del inline tiene DOS listas —la
// tanda recién generada y la sección "Recientes" / "Imágenes anteriores"— y esto
// miraba solo la primera. Tocar una creación anterior la deja seleccionada
// igual, así que la lista salía vacía, `EnviarALanzamiento` con cero fotos no se
// dibujaba, y en la barra no quedaba NINGÚN botón: tampoco el de descargar,
// porque el ternario ya había elegido el de lanzamiento.
//
// Separado del componente (6000 líneas) para que la regla se pueda probar: es
// una función de dos listas y una selección.

/** Lo mínimo que una creación necesita para poder ir a un lanzamiento. */
export interface CreacionSeleccionable {
  id: string;
  fileName?: string | null;
  isVideo?: boolean;
  variante_id?: string | number | null;
  variantes_ids?: string[] | null;
  datos_generacion?: unknown;
}

/**
 * Las seleccionadas, buscándolas en TODAS las listas que la pantalla muestra.
 *
 * El orden de `listas` importa: si una creación está en más de una, gana la
 * primera — es la que tiene los datos más frescos (la tanda recién generada sabe
 * de la generación lo que el historial todavía no volvió a leer).
 *
 * El resultado sale en el orden en que aparecen en las listas, no en el orden en
 * que se fueron tildando: es el orden que el usuario ve en pantalla.
 */
export function seleccionParaLanzamiento<T extends CreacionSeleccionable>(
  listas: ReadonlyArray<readonly T[]>,
  seleccionados: readonly string[],
): T[] {
  const elegidas = new Set(seleccionados);
  const vistas = new Set<string>();
  const out: T[] = [];
  for (const lista of listas) {
    for (const img of lista) {
      if (!elegidas.has(img.id) || vistas.has(img.id)) continue;
      vistas.add(img.id);
      out.push(img);
    }
  }
  return out;
}
